import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";

import video from "../assets/videos/hardrevcut.mp4";
import imageurl1 from "../assets/images/hardrevcut1.png";
import imageurl2 from "../assets/images/hardrevcut2.png";
import video2 from "../assets/videos/service2.mp4";

function HardRevCut() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Bij de meeste auto's is de ECU ontworpen om de acceleratiekracht te
        verminderen wanneer het toerental de toerenbegrenzer nadert. Dit
        betekent dat de acceleratie in dit toerentalbereik wordt belemmerd en
        dat de motor slechts een deel van zijn vermogen vrijgeeft.
      </p>
      <br />
      <p className="text-white text-lg">
        Bij X-TREMETUNINGS bieden we de service om deze Hard Rev Cut te
        deactiveren door de software in uw auto opnieuw te programmeren.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">
        Dit geeft als resultaat dat de motor de toerentalbegrenzer kan bereiken
        zonder dat er sprake is van vermogensverlies. Hierdoor gaat er geen tijd
        verloren en wordt het vermogen maximaal benut.
        <br />
        Bijkomend voordeel is het feit dat het gevoel en de voorspelling van het
        maximaal toerental redline veel beter zijn. U heeft volledige controle
        over uw motor en kunt het maximaal benutten.
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="HARD REV CUT" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default HardRevCut;
